<footer class="footer-container {{lookAndFeelService.getLookAndFeel()}}" role="contentinfo">
    <div class="row no-gutter pt-2">

    </div>
</footer>
